var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabDiv d-flex py-5"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i},[_c('v-btn',{staticClass:"text-none px-7 py-7 mr-2",class:{
        active__class: i == _vm.selectedTab,
        inactive__class: i !== _vm.selectedTab,
      },attrs:{"color":i == _vm.selectedTab ? '#2d8cff' : '#EAEDF0'},on:{"click":function($event){_vm.selectedTab = i}}},[_c('span',[_vm._v(_vm._s(item.title))])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }